import React from 'react';

// Helper funktion til at vise en kamp - minimalistisk stil
const MatchDisplay = ({ match, predictedWinner, realWinner = '' }) => {
  const isCorrect = realWinner && predictedWinner === realWinner;
  const homeSelected = match.home === predictedWinner;
  const awaySelected = match.away === predictedWinner;
  
  const isIncorrect = realWinner && !isCorrect;
  
  return (
    <div className={`match-display-minimal ${isCorrect ? 'match-correct' : ''} ${isIncorrect ? 'match-incorrect' : ''}`}>
      <button 
        className={`team-button-minimal ${homeSelected ? 'selected' : ''}`}
        disabled
      >
        {match.home}
      </button>
      <span className="vs-minimal">VS</span>
      <button 
        className={`team-button-minimal ${awaySelected ? 'selected' : ''}`}
        disabled
      >
        {match.away}
      </button>
      {realWinner && (
        <span className={`result-indicator ${isCorrect ? 'correct' : 'incorrect'}`}>
          {isCorrect ? '✓' : '✗'}
        </span>
      )}
    </div>
  );
};

export default MatchDisplay;
